import React, { useEffect } from 'react';
import { Form, Select, Row, Col, Input } from 'antd';
import isEmpty from 'lodash/isEmpty';

const { Option } = Select;
const itemLayout = {
  md: 8,
  sm: 12,
};
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
};

const FormInput = ({ form: { getFieldDecorator, validateFields, resetFields }, onSearch, loadingCategory, categories, loadingFreq, freq, spam, onChangeFields, isReset, isResetDataComp, isCrisisForm, brands, loadingBuzz, categoryNameChosen }) => {
  const filteredBrands = !isEmpty(brands) ? brands.filter(brand => brand.category === categoryNameChosen) : [];

  useEffect(() => {
    if (isReset) {
      resetFields();
    }
  }, [isReset, resetFields]);

  useEffect(() => {
    if (isResetDataComp) {
      resetFields('brand');
    }
  }, [isResetDataComp, resetFields]);

  return (
    <Form>
      <Row gutter={32}>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="CRM ID">
            {getFieldDecorator('project', {
              initialValue: '',
              rules: [{required: true, message: 'Vui lòng nhập dữ liệu bắt buộc'}],
            })(<Input onBlur={e => { onChangeFields({ 'project': e.target.value }) }} placeholder='Vui lòng nhập CRM ID' />)}
          </Form.Item>
        </Col>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Category">
            {getFieldDecorator('category', {
              initialValue: [],
              rules: [{required: true, message: 'Vui lòng chọn dữ liệu bắt buộc'}],
            })(<Select optionFilterProp="children" showSearch filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
            } loading={loadingCategory} placeholder='Vui lòng chọn Category'>
            {categories.map(category => <Option key={category.key} value={`${category.name}_${category.level}_${category.monitor_by_level}_${category.clarify_speed}_${category.spam}_${category.report_level}_${category.saving_percent}`}>{category.name}</Option>)}
          </Select>)}
          </Form.Item>
          {spam ? <div style={{ textAlign: 'right' }} className='gx-text-danger'>(SPAM: {spam}%)</div> : ''}
        </Col>
        <Col {...itemLayout}>
          {isCrisisForm ? <Form.Item {...formItemLayout} label="Brand">
            {getFieldDecorator('brand', {
              initialValue: ['none_0'],
              rules: [{required: true, message: 'Vui lòng chọn dữ liệu bắt buộc'}],
            })(<Select disabled={!categoryNameChosen} loading={loadingBuzz} style={{ width: 200 }} optionFilterProp="children" showSearch filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
            }>
              <Option key='none' value="none_0">Chọn brand</Option>
              {filteredBrands.map(brand => <Option key={brand.brand} value={`${brand.brand}_${brand.value}`}>{brand.brand}</Option>)}
            </Select>)}
          </Form.Item> : <Form.Item {...formItemLayout} label="Frequency">
            {getFieldDecorator('data_freq', {
              initialValue: ['Monthly'],
            })(<Select loading={loadingFreq} placeholder='Vui lòng chọn Frequency'>
              {freq.map(item => <Option key={item.key} value={item.name}>{item.name}</Option>)}
            </Select>)}
          </Form.Item>}
        </Col>
      </Row>
    </Form>
  );
};
export default Form.create({
  name: 'form_input_quotas',
  onValuesChange: (props, changedValues) => {
    const { onChangeFields } = props;
    if (changedValues.category || changedValues.data_freq || changedValues.brand) {
      onChangeFields(changedValues);
    }
  },
})(FormInput);
